import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/round creams/round mango biscuit.png";
import BiscuitImg from "../../../assets/products/round creams/Round-Mango.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 13,
  },
  {
    grams: 18,
  },
  {
    grams: 20,
  },
  {
    grams: 30,
  },
  {
    grams: 40,
  },
  {
    grams: 50,
  },
  {
    grams: 70,
  },
  {
    grams: 90,
  },
];

export default function MangoRoundProduct() {
  return (
    <>
      <Helmet>
        <title>
          Round Mango Cream Biscuit – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Round Mango Cream Biscuits — juicy mango-flavored sandwich biscuits with creamy filling. View pack sizes, cartons, and specs."
        />
        <meta
          name="keywords"
          content="Round Mango Cream Biscuit, BearBitz Mango Cream Biscuit"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/round-cream-biscuit/round-mango"
        />
        <meta
          property="og:title"
          content="Round Mango Cream Biscuit – BearBitz"
        />
        <meta
          property="og:description"
          content="Cream-filled mango sandwich biscuit in round shape with premium packaging and export-ready specs."
        />
      </Helmet>

      <ProductTemplate
        productTitle="MANGO"
        productImage={BisImg}
        description="Sweet Layers of Joy.Crunchy biscuits filled with rich cream—classic favorites in every shape and flavor. A global snack sensation that delights with every bite."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#FF8D00"
        sectionBgColor="#FFEFC2"
        productBgcolor="#FFDE85"
        tableheadBgcolor="#FF8D00"
        tableBgcolor="#FFF9E7"
        footerBgcolor="#FF8D00"
      />
    </>
  );
}
